declare let API_HREF: string;
// Dependencies
import axios from 'axios';
// import { useSnackbar } from 'notistack';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import React, { FC, ReactElement, useContext, useEffect } from 'react';
// Core & Lab
import Button from '@mui/material/Button';
// Actions
import {
    addSelection,
    setAdding,
    addCustomPictures,
    updateProgress,
    updatePicturesForm,
} from './redux/actions';
// Utils
import { PictureContext } from './utils/pictureContext';
// Types
import { AppState } from '../../reducers';
import { useShowError } from '../../functions/useShowError';
import { PictureLocale } from './objects/picture';

const PictureCreate: FC = (): ReactElement => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    // const { enqueueSnackbar } = useSnackbar();
    const showError = useShowError();
    const client_id = useSelector((state: AppState) => state.header.client_id);
    const adding = useSelector((state: AppState) => state.picture.adding);
    const pictures = useSelector((state: AppState) => state.picture.pictures_form);
    const selection = useSelector((state: AppState) => state.picture.selection);
    const create_name_locales = useSelector((state: AppState) => state.picture.create_name_locales);
    const create_alt = useSelector((state: AppState) => state.picture.create_alt);
    const create_credit = useSelector((state: AppState) => state.picture.create_credit);
    const create_description = useSelector((state: AppState) => state.picture.create_description);
    const current_locale = useSelector((state: AppState) => state.locale.current_locale);
    const create_type = useSelector((state: AppState) => state.picture.create_type);
    const create_picture_category = useSelector((state: AppState) => state.picture.create_picture_category);
    const pictureContext = useContext(PictureContext);

    const onCreate = () => {
        dispatch(setAdding(true));
        pictures.map((picture, file_index) => {
            const request = new FormData();

            const localization: PictureLocale[] = [];

            Object.entries(create_name_locales).forEach(([key, value]) => {
                localization.push({
                    locale: Number(key),
                    name: value
                });
            });

            request.append('localization', JSON.stringify(localization));

            request.append('name', create_name_locales[Number(current_locale)] || "");
            if (create_alt) {
                request.append('alt', create_alt || "");
            }

            if (create_credit) {
                request.append('credits', create_credit || "");
            }

            if (create_description) {
                request.append('description', create_description || "");
            }

            if (create_picture_category !== null) {
                request.append('picture_category', String(create_picture_category));
            }

            request.append('image', picture.file);
            axios({
                method: 'POST',
                url: `${API_HREF}client/${client_id}/pictures/`,
                headers: {
                    'Authorization': `Token ${localStorage.getItem('token')}`
                },
                params: {
                    type: (create_type || 'PICTURE')
                },
                data: request,
                onUploadProgress: (progressEvent) => {
                    dispatch(updateProgress(progressEvent.loaded / progressEvent.total * 100));
                }
            }).then((response) => {
                dispatch(addSelection(response.data, picture.name));
            }).catch((error) => {
                dispatch(updatePicturesForm(pictures.filter((_, i) => i !== file_index)));
                showError(error);
            }).finally(() => {
                dispatch(updateProgress(0));
            });
        });
    };
    useEffect(() => {
        if (adding && pictures.length === 0) {
            dispatch(addCustomPictures(selection));
            // if (manual_accommodation !== null) {
            if (pictureContext.onChangePictures) {
                pictureContext.onChangePictures(selection);
            }
            // }
        }
    }, [adding, pictures]);
    return (
        <PictureContext.Consumer>
            {({ disabled }) => (
                <Button
                    onClick={onCreate}
                    disabled={
                        disabled ||
                        pictures.length === 0 && selection.length === 0
                    }
                >
                    {t('shared.validate-selection')}
                </Button>
            )}
        </PictureContext.Consumer>
    );
};

export default PictureCreate;
